var _rect, _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSlack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.8889 58.4444C32.8889 62.0084 30.0084 64.8889 26.4444 64.8889C22.8805 64.8889 20 62.0084 20 58.4444C20 54.8805 22.8805 52 26.4444 52H32.8889V58.4444ZM36.1111 58.4444C36.1111 54.8805 38.9916 52 42.5556 52C46.1195 52 49 54.8805 49 58.4444V74.5556C49 78.1195 46.1195 81 42.5556 81C38.9916 81 36.1111 78.1195 36.1111 74.5556V58.4444Z",
    fill: "#E01E5A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5664 32.8672C39.0084 32.8672 36.1328 29.9916 36.1328 26.4336C36.1328 22.8756 39.0084 20 42.5664 20C46.1244 20 49 22.8756 49 26.4336V32.8672H42.5664ZM42.5664 36.1328C46.1244 36.1328 49 39.0084 49 42.5664C49 46.1244 46.1244 49 42.5664 49H26.4336C22.8756 49 20 46.1244 20 42.5664C20 39.0084 22.8756 36.1328 26.4336 36.1328H42.5664Z",
    fill: "#36C5F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1111 42.5664C68.1111 39.0084 70.9916 36.1328 74.5556 36.1328C78.1195 36.1328 81 39.0084 81 42.5664C81 46.1244 78.1195 49 74.5556 49H68.1111V42.5664ZM64.8889 42.5664C64.8889 46.1244 62.0084 49 58.4444 49C54.8805 49 52 46.1244 52 42.5664V26.4336C52 22.8756 54.8805 20 58.4444 20C62.0084 20 64.8889 22.8756 64.8889 26.4336V42.5664Z",
    fill: "#2EB67D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4336 68.1111C61.9916 68.1111 64.8672 70.9916 64.8672 74.5556C64.8672 78.1195 61.9916 81 58.4336 81C54.8756 81 52 78.1195 52 74.5556V68.1111H58.4336ZM58.4336 64.8889C54.8756 64.8889 52 62.0084 52 58.4444C52 54.8805 54.8756 52 58.4336 52H74.5664C78.1244 52 81 54.8805 81 58.4444C81 62.0084 78.1244 64.8889 74.5664 64.8889H58.4336Z",
    fill: "#ECB22E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlack);
export default __webpack_public_path__ + "static/media/Slack.346a9be5f6d1f907913cc3808ecdf14c.svg";
export { ForwardRef as ReactComponent };